import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'gaweb-travel-alternatives-panel',
    templateUrl: 'travel-alternatives-panel.component.html'
})
export class TravelAlternativesPanelComponent {
    @Input() availabilityDataExists: boolean;
    @Input() alternateTravelExists: boolean;
    @Input() betterAlternateTravelExists: boolean;
    @Input() dayBefore: string;
    @Input() dayAfter: string;
    @Input() betterDayBefore: string;
    @Input() betterDayAfter: string;
    @Input() showPreviousDay: boolean;
    @Output() doPrevDay: EventEmitter<any> = new EventEmitter();
    @Output() doNextDay: EventEmitter<any> = new EventEmitter();
    @Output() doBetPrevDay: EventEmitter<any> = new EventEmitter();
    @Output() doBetNextDay: EventEmitter<any> = new EventEmitter();

    nextDay() {
        this.doNextDay.emit();
    }

    prevDay() {
        this.doPrevDay.emit();
    }

    betNextDay() {
        this.doBetNextDay.emit();
    }

    betPrevDay() {
        this.doBetPrevDay.emit();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/travel-dates/travel-alternatives-panel/travel-alternatives-panel.component.ts